/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    CLEAR_RATE_LIMITED_MONTHS,
    FETCH_MONTHLY_AVAILABILITY,
    CLEAR_CAMPSITE_AVAILABILITY,
    SET_AVAILABILITY_QUERY_ENABLED,
} from '../constants';

export const fetchCampgroundAvailability = ({
    startDate,
    endDate,
    shouldRefresh = false,
    facilityId,
    isInternal = false,
    isModify = false,
}: {
    startDate: string;
    endDate?: string | null;
    shouldRefresh?: boolean;
    facilityId?: string;
    isInternal?: boolean;
    isModify?: boolean;
}) => {
    return {
        type: FETCH_MONTHLY_AVAILABILITY,
        payload: {
            startDate,
            endDate,
            shouldRefresh,
            facilityId,
            isInternal,
            isModify,
        },
    };
};

export const clearCampsiteAvailability = () => {
    return {
        type: CLEAR_CAMPSITE_AVAILABILITY,
    };
};

export const clearRateLimitedMonths = () => {
    return {
        type: CLEAR_RATE_LIMITED_MONTHS,
    };
};

/**
 * Hand control of availability fetching to useMonthlyAvailability (React Query).
 * While enabled, fetchMonthlyAvailabilityEpic ignores FETCH_MONTHLY_AVAILABILITY so the
 * two paths never fetch concurrently. Pages that mount useMonthlyAvailability enable it on
 * mount and disable it on unmount.
 */
export const setAvailabilityQueryEnabled = (isEnabled: boolean) => {
    return {
        type: SET_AVAILABILITY_QUERY_ENABLED,
        payload: isEnabled,
    };
};
